import { Hex, isHex } from 'viem'

import { usePastStateChanges } from '~/components/txn-display/state-change/hooks/usePastStateChanges'
import { buildWatchAddresses } from '~/components/txn-display/state-change/utils/buildWatchAddresses'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'
import { parseTransactionMetadata } from '~/utils/parseTransactionMetadata'

export const useBridgePastStateChanges = (
  transaction?: OrgRegularTransaction | PublicRegularTransaction,
) => {
  const transactionMetadata = transaction
    ? parseTransactionMetadata(transaction.transactionMetadata)
    : undefined

  let transactionHash: Hex | undefined
  let chainId: number | undefined

  if (transactionMetadata?.bridgeData?.status === 'SUCCESS') {
    if (isHex(transactionMetadata.bridgeData.destinationTransaction?.hash)) {
      transactionHash =
        transactionMetadata.bridgeData.destinationTransaction.hash
      chainId = transactionMetadata.bridgeData.destinationChainId
    }
  }

  if (transactionMetadata?.bridgeData?.status === 'FAILURE') {
    if (isHex(transactionMetadata.bridgeData.refundTransaction?.hash)) {
      transactionHash = transactionMetadata.bridgeData.refundTransaction.hash
      chainId = transaction?.chainId
    }
  }

  return usePastStateChanges({
    transactionHash,
    chainId,
    addressesToWatch: transaction ? buildWatchAddresses(transaction) : [],
    transactionTime: transaction?.transactionTime,
  })
}
